import React, { useEffect, useState } from "react";

import axios from "axios";
import "@fontsource/chivo";
import { QRCodeCanvas } from "qrcode.react";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import QRCode from "qrcode"; // Add at top


const PostiManager = () => {
  const [postiData, setPostiData] = useState([]);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [newPosto, setNewPosto] = useState({ posto: "", pin: "", stato: "ATTIVO" });
  const [editingId, setEditingId] = useState(null);
  const [editedPosto, setEditedPosto] = useState({});
  const [statusMessage, setStatusMessage] = useState(null);
  const [qrPosto, setQrPosto] = useState(null);


  useEffect(() => {
    fetchPosti();
  }, []);

  const fetchPosti = () => {
    axios.get("https://api.lidodavittorio.it/api/posti").then((res) => {
      setPostiData(res.data);
    });
  };

  const handleNewInputChange = (e) => {
    const { name, value } = e.target;
    setNewPosto((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddPosto = () => {
    const { posto, pin, stato } = newPosto;
    if (!posto || !pin || !stato) return setStatusMessage("❌ Tutti i campi sono obbligatori.");

    axios
      .post("https://api.lidodavittorio.it/api/posti/add", newPosto)
      .then(() => {
        setStatusMessage("✅ Posto aggiunto con successo!");
        setNewPosto({ posto: "", pin: "", stato: "ATTIVO" });
        fetchPosti();
      })
      .catch(() => setStatusMessage("❌ Errore durante l'aggiunta."));
  };

  const handleEditClick = (posto) => {
    setEditingId(posto.id);
    setEditedPosto({ ...posto });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditedPosto((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveEdit = () => {
    axios
      .post("https://api.lidodavittorio.it/api/posti/update", editedPosto)
      .then(() => {
        setStatusMessage("✅ Posto modificato con successo!");
        setEditingId(null);
        fetchPosti();
      })
      .catch(() => setStatusMessage("❌ Errore durante la modifica."));
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedPosto({});
  };

  const handleDelete = (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo posto?")) return;

    axios.post("https://api.lidodavittorio.it/api/posti/delete", { id }).then(() => {
      setStatusMessage("🗑️ Posto eliminato con successo!");
      fetchPosti();
    });
  };

  const filteredPosti = postiData.filter(
    (p) => p.posto.toLowerCase().includes(filter.toLowerCase())
  );

  const totalPages = Math.ceil(filteredPosti.length / itemsPerPage);
  const sortedPosti = [...filteredPosti].sort((a, b) => {
    // Natural alphanumeric sort, e.g., A1 < A10 < B2
    return a.posto.localeCompare(b.posto, undefined, { numeric: true, sensitivity: 'base' });
  });
  
  const paginatedPosti = sortedPosti.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  
  const handlePageChange = (dir) => {
    if (dir === "prev" && currentPage > 1) setCurrentPage((p) => p - 1);
    else if (dir === "next" && currentPage < totalPages) setCurrentPage((p) => p + 1);
  };


  

const generateQRPdfForAll = async () => {
  const activePosti = postiData.filter((p) => p.stato === "ATTIVO");
  if (activePosti.length === 0) {
    setStatusMessage("❌ Nessun posto ATTIVO trovato.");
    return;
  }

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "cm",
    format: [7, 11], // width x height in cm
  });

  for (let i = 0; i < activePosti.length; i++) {
    const posto = activePosti[i];
    const qrValue = `https://www.lidodavittorio.it/menu?posto=${encodeURIComponent(
      posto.posto
    )}&pin=${encodeURIComponent(posto.pin)}`;

    const qrImg = await QRCode.toDataURL(qrValue, {
      width: 300,
      margin: 1,
    });

    // Add border
    doc.setDrawColor(0);
    doc.setLineWidth(0.05);
    doc.rect(0.2, 0.2, 6.6, 10.6); // border with padding

    // Add QR code (3.5 cm wide, centered horizontally)
    doc.addImage(qrImg, "PNG", 1.75, 1.5, 3.5, 3.5);

    // Add large POSTO code centered below QR
    doc.setFontSize(80.5);
    doc.setTextColor(128, 0, 32); // dark red
    doc.setFont("helvetica", "bold");
    doc.text(posto.posto, 3.5, 9.5, { align: "center" });

    if (i < activePosti.length - 1) doc.addPage();
  }

  doc.save("QR_Posti_7x11.pdf");
};





  const handleAddMultiplePosti = async () => {
    const filesCount = parseInt(newPosto.filesCount, 10);
    const postiPerFila = parseInt(newPosto.postiPerFila, 10);
    if (!filesCount || !postiPerFila || filesCount > 26) {
      setStatusMessage("❌ Inserisci valori validi (max 26 file).");
      return;
    }
  
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").slice(0, filesCount);
    const generated = [];
  
    for (const letter of letters) {
      for (let i = 1; i <= postiPerFila; i++) {
        const posto = `${letter}${i}`;
        const pin = Math.floor(1000 + Math.random() * 9000).toString(); // 4-digit random pin
        generated.push({ posto, pin, stato: "ATTIVO" });
      }
    }
  
    try {
      const res = await axios.post("https://api.lidodavittorio.it/api/posti/add-multiple", { posti: generated });
      setStatusMessage(`✅ Aggiunti ${res.data.inserted} nuovi posti (escludendo duplicati).`);
      fetchPosti();
    } catch (err) {
      setStatusMessage("❌ Errore durante l'aggiunta multipla.");
    }
  };
  
  
  

  return (
    <div className="overflow-x-auto font-[chivo]">
      <h2 className="text-2xl font-bold text-[#009FB7] mb-6">Gestione Posti</h2>
  
      {/* Filter */}
      <input
        type="text"
        placeholder="Filtra per posto..."
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value);
          setCurrentPage(1);
        }}
        className="border px-3 py-2 rounded mb-4 w-full sm:w-1/2"
      />
  
      {/* Add Multiple Posti */}
      <div className="mb-4 flex flex-wrap gap-2 items-end">
        <input
          type="number"
          min="1"
          max="26"
          placeholder="Numero di file (A-Z)"
          className="border px-2 py-1 rounded w-[180px]"
          value={newPosto.filesCount || ""}
          onChange={(e) => setNewPosto({ ...newPosto, filesCount: e.target.value })}
        />
        <input
          type="number"
          min="1"
          placeholder="Numero di posti per fila"
          className="border px-2 py-1 rounded w-[200px]"
          value={newPosto.postiPerFila || ""}
          onChange={(e) => setNewPosto({ ...newPosto, postiPerFila: e.target.value })}
        />
        <button
          onClick={handleAddMultiplePosti}
          className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
        >
          ➕ Aggiungi Multipli
        </button>
      </div>
  
      {/* Add Single Posto */}
      <div className="mb-4 flex flex-wrap gap-2 items-end">
        <input
          type="text"
          name="posto"
          placeholder="Posto"
          value={newPosto.posto}
          onChange={handleNewInputChange}
          className="border px-2 py-1 rounded w-full sm:w-[150px]"
        />
        <input
          type="text"
          name="pin"
          placeholder="PIN"
          value={newPosto.pin}
          onChange={handleNewInputChange}
          className="border px-2 py-1 rounded w-full sm:w-[150px]"
        />
        <select
          name="stato"
          value={newPosto.stato}
          onChange={handleNewInputChange}
          className="border px-2 py-1 rounded w-full sm:w-[130px]"
        >
          <option value="ATTIVO">ATTIVO</option>
          <option value="NON ATTIVO">NON ATTIVO</option>
        </select>
        <button
          onClick={handleAddPosto}
          className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
        >
          ➕ Aggiungi
        </button>
        <button
          onClick={generateQRPdfForAll}
          className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
        >
          🧾 Genera PDF con QR
        </button>
      </div>
  
      {/* Status Message */}
      {statusMessage && (
        <div className="mb-4 text-sm font-semibold text-center text-[#009FB7]">
          {statusMessage}
        </div>
      )}
  
      <table className="w-full border-collapse text-sm sm:text-base">
        <thead>
          <tr className="bg-[#009FB7] text-white">
            <th className="p-3 border">ID</th>
            <th className="p-3 border">Posto</th>
            <th className="p-3 border">PIN</th>
            <th className="p-3 border">Stato</th>
            <th className="p-3 border text-center">Azioni</th>
          </tr>
        </thead>
        <tbody>
          {paginatedPosti.map((posto) => (
            <tr key={posto.id} className="border-b hover:bg-gray-100">
              <td className="p-3">{posto.id}</td>
              <td className="p-3">
                {editingId === posto.id ? (
                  <input
                    type="text"
                    name="posto"
                    value={editedPosto.posto}
                    onChange={handleEditInputChange}
                    className="w-full border px-2 py-1 rounded"
                  />
                ) : (
                  posto.posto
                )}
              </td>
              <td className="p-3">
                {editingId === posto.id ? (
                  <input
                    type="text"
                    name="pin"
                    value={editedPosto.pin}
                    onChange={handleEditInputChange}
                    className="w-full border px-2 py-1 rounded"
                  />
                ) : (
                  posto.pin
                )}
              </td>
              <td className="p-3">
                {editingId === posto.id ? (
                  <select
                    name="stato"
                    value={editedPosto.stato}
                    onChange={handleEditInputChange}
                    className="w-full border px-2 py-1 rounded"
                  >
                    <option value="ATTIVO">ATTIVO</option>
                    <option value="NON ATTIVO">NON ATTIVO</option>
                  </select>
                ) : (
                  <span
                    className={`font-bold ${
                      posto.stato === "ATTIVO" ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {posto.stato}
                  </span>
                )}
              </td>
              <td className="p-3 text-center space-x-1">
                {editingId === posto.id ? (
                  <>
                    <button
                      onClick={handleSaveEdit}
                      className="bg-[#009FB7] text-white px-2 py-1 rounded hover:bg-[#007a91]"
                    >
                      Salva
                    </button>
                    <button
                      onClick={handleCancelEdit}
                      className="bg-gray-400 text-white px-2 py-1 rounded hover:bg-gray-500"
                    >
                      Annulla
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => handleEditClick(posto)}
                      className="text-yellow-500 text-lg hover:text-yellow-600"
                      title="Modifica"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDelete(posto.id)}
                      className="text-red-600 font-bold px-2 hover:text-red-800"
                      title="Elimina"
                    >
                      🗑
                    </button>
                    <button
                      onClick={() => setQrPosto(posto)}
                      className="text-blue-600 font-bold px-2 hover:text-blue-800"
                      title="QR Code"
                    >
                      📱
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
  
      {/* Pagination Controls */}
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          onClick={() => handlePageChange("prev")}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          ◀ Precedente
        </button>
        <span>
          Pagina <strong>{currentPage}</strong> di <strong>{totalPages}</strong>
        </span>
        <button
          onClick={() => handlePageChange("next")}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          Prossimo ▶
        </button>
      </div>
  
      {/* QR Code Display */}
      {qrPosto && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg text-center relative">
      <button
        onClick={() => setQrPosto(null)}
        className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl"
        title="Chiudi"
      >
        ❌
      </button>
      <h3 className="text-lg font-semibold mb-4 text-[#009FB7]">
        QR Code per il Posto: {qrPosto.posto}
      </h3>
      <QRCodeCanvas
        id="qr-code"
        value={`https://www.lidodavittorio.it/menu?posto=${encodeURIComponent(qrPosto.posto)}&pin=${encodeURIComponent(qrPosto.pin)}`}
        size={300}
        includeMargin
      />
      <div className="mt-4">
        <button
          onClick={() => {
            const canvas = document.getElementById("qr-code");
            const pngUrl = canvas
              .toDataURL("image/png")
              .replace("image/png", "image/octet-stream");
            const link = document.createElement("a");
            link.href = pngUrl;
            link.download = `QR_${qrPosto.posto}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
          className="mt-3 bg-[#009FB7] text-white px-4 py-2 rounded hover:bg-[#007a91]"
        >
          ⬇️ Scarica QR Code
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
  
};

export default PostiManager;
